(() => {
function initSizeCharts(scope) { scope.querySelectorAll('[data-hv-sizechart]').forEach(function(root) {
      if (!root || root.dataset.hvReady === 'true') return;
      root.dataset.hvReady = 'true';

      var opener = root.querySelector('.hv-sizechart__open');
      var dialog = root.querySelector('.hv-sizechart__dialog');
      var dataElement = root.querySelector('.hv-sizechart__values');
      if (!opener || !dialog || !dataElement) return;

      var sizeData;
      try {
        sizeData = JSON.parse(dataElement.textContent);
      } catch (error) {
        sizeData = { optionName: 'Size', values: [] };
      }

      var productArea = root.closest('product-information, .product-information, section') || document;
      if (productArea instanceof HTMLElement) productArea.classList.add('hv-has-sizechart');

      // One delegated mobile trigger per product area survives variant-picker morphs without
      // moving nodes around or reserving a blank block in the product-details stack.
      if (productArea instanceof HTMLElement && productArea.dataset.hvSizeChartDelegated !== 'true') {
        productArea.dataset.hvSizeChartDelegated = 'true';
        productArea.addEventListener('click', function (event) {
          var trigger = event.target instanceof Element ? event.target.closest('[data-hv-sizechart-mobile-opener]') : null;
          if (!trigger || !productArea.contains(trigger)) return;
          var currentDialog = productArea.querySelector('.hv-sizechart__dialog');
          if (!currentDialog) return;
          if (currentDialog.showModal) currentDialog.showModal();
          else currentDialog.setAttribute('open', '');
        });
      }

      function normalise(value) {
        return String(value || '').toLowerCase().replace(/\u00a0/g, ' ').replace(/\s+/g, '').replace(/[()_-]/g, '');
      }

      function numericLabel(value) {
        var match = String(value || '').replace(/,/g, '.').match(/(?:uk\s*)?(\d+(?:\.\d+)?)/i);
        return match ? Number(match[1]) : null;
      }

      function rowLabel(row) {
        return row && row.cells[0] ? row.cells[0].textContent.trim() : '';
      }

      function exactRow(rows, value) {
        var wanted = normalise(value);
        var withoutUk = wanted.replace(/^uk/, '');
        return rows.find(function (row) {
          var label = normalise(rowLabel(row));
          return label === wanted || label.replace(/^uk/, '') === withoutUk;
        });
      }

      function mappedRows(rows, value) {
        var direct = exactRow(rows, value);
        if (direct) return [direct];

        var key = normalise(value);
        var letterToUk = { xxs: 'UK 2', xs: 'UK 4', s: 'UK 6', m: 'UK 8', l: 'UK 10', xl: 'UK 12', '2xl': 'UK 14', '3xl': 'UK 16', '4xl': 'UK 18' };
        if (letterToUk[key]) {
          var mapped = exactRow(rows, letterToUk[key]);
          return mapped ? [mapped] : [];
        }

        if (key === 'onesize') return rows.slice();

        var rangeMatch = String(value || '').match(/uk\s*(\d+(?:\.\d+)?)\s*\/\s*(\d+(?:\.\d+)?)/i);
        if (rangeMatch) {
          return [exactRow(rows, 'UK ' + rangeMatch[1]), exactRow(rows, 'UK ' + rangeMatch[2])].filter(Boolean);
        }

        var targetNumber = numericLabel(value);
        if (targetNumber !== null) {
          var numberedRows = rows
            .map(function (row) { return { row: row, number: numericLabel(rowLabel(row)) }; })
            .filter(function (item) { return item.number !== null; })
            .sort(function (a, b) { return a.number - b.number; });
          var lower = numberedRows.filter(function (item) { return item.number < targetNumber; }).pop();
          var upper = numberedRows.find(function (item) { return item.number > targetNumber; });
          if (lower && upper) return [lower.row, upper.row];
          if (lower) return [lower.row];
          if (upper) return [upper.row];
        }

        return [];
      }

      function combinedValue(sourceRows, cellIndex) {
        var values = sourceRows.map(function (row) {
          return row.cells[cellIndex] ? row.cells[cellIndex].textContent.trim() : '';
        }).filter(Boolean);
        var uniqueValues = values.filter(function (value, index) { return values.indexOf(value) === index; });
        if (uniqueValues.length <= 1) return uniqueValues[0] || '';

        var numericValues = uniqueValues.map(function (value) {
          return /^-?\d+(?:[.,]\d+)?$/.test(value) ? Number(value.replace(',', '.')) : null;
        });
        if (numericValues.every(function (value) { return value !== null; })) {
          var minimum = Math.min.apply(Math, numericValues);
          var maximum = Math.max.apply(Math, numericValues);
          return minimum === maximum ? String(minimum) : minimum + '–' + maximum;
        }
        return uniqueValues.join('–');
      }

      function chartRow(value, sourceRows) {
        var row = sourceRows[0].cloneNode(true);
        row.cells[0].textContent = value;
        if (sourceRows.length > 1) {
          for (var index = 1; index < row.cells.length; index += 1) {
            row.cells[index].textContent = combinedValue(sourceRows, index);
          }
        }
        return row;
      }

      function alignChartToProductSizes() {
        var table = dialog.querySelector('table');
        var body = table && table.querySelector('tbody');
        var values = Array.isArray(sizeData.values) ? sizeData.values.filter(Boolean) : [];
        if (!table || !body || values.length === 0) return;

        var originalRows = Array.from(body.querySelectorAll('tr'));
        if (originalRows.length === 0) return;
        if (sizeData.isFootwear) {
          var shoeRows = values.map(function (value) {
            var size = String(value).replace(/^US\s*/i, '').trim();
            return originalRows.find(function (row) { return rowLabel(row) === size; });
          });
          if (shoeRows.every(Boolean)) body.replaceChildren.apply(body, shoeRows);
          return;
        }

        var alignedRows = [];
        var allResolved = values.every(function (value) {
          var sources = mappedRows(originalRows, value);
          if (sources.length === 0) return false;
          alignedRows.push(chartRow(value, sources));
          return true;
        });
        if (!allResolved) return;

        body.replaceChildren.apply(body, alignedRows);
        var firstHeading = table.querySelector('th');
        if (firstHeading) firstHeading.textContent = /uk/i.test(sizeData.optionName || '') ? 'UK Size' : 'Size';
      }

      alignChartToProductSizes();

      opener.addEventListener('click', function () {
        if (dialog.showModal) dialog.showModal();
        else dialog.setAttribute('open', '');
      });
      dialog.querySelector('.hv-sizechart__close').addEventListener('click', function () {
        if (dialog.close) dialog.close();
        else dialog.removeAttribute('open');
      });
      dialog.addEventListener('click', function (event) {
        if (event.target === dialog && dialog.close) dialog.close();
      });
      dialog.querySelectorAll('.hv-sizechart__unit').forEach(function (button) {
        button.addEventListener('click', function () {
          dialog.querySelectorAll('.hv-sizechart__unit').forEach(function (unitButton) { unitButton.classList.remove('is-active'); });
          button.classList.add('is-active');
          dialog.setAttribute('data-show', button.dataset.unit);
        });
      });
    
}); }
function initReviews(scope) { scope.querySelectorAll('[data-hv-review-section]').forEach((root) => {
    if (!root || root.dataset.reviewsReady === 'true') return;
    root.dataset.reviewsReady = 'true';

    const items = Array.from(root.querySelectorAll('[data-review-item]'));
    const button = root.querySelector('[data-review-more]');
    if (!button) return;

    const moreWrap = root.querySelector('.hv-customer-reviews__more-wrap');
    let visible = 3;
    const initialVisible = visible;

    const render = () => {
      items.forEach((item, index) => item.classList.toggle('hv-review-card--hidden', index >= visible));
      const done = visible >= items.length;
      button.setAttribute('aria-expanded', String(visible > initialVisible));
      button.hidden = done;
      if (moreWrap) moreWrap.hidden = done;
      return done;
    };

    button.addEventListener('click', () => {
      const firstNewIndex = visible;
      visible = Math.min(visible + 3, items.length);
      const done = render();

      // If the control disappears after the final batch, keep keyboard focus in a meaningful place.
      if (done) {
        const firstNewReview = items[firstNewIndex];
        if (firstNewReview) {
          firstNewReview.setAttribute('tabindex', '-1');
          firstNewReview.focus({ preventScroll: true });
        }
      }
    });

    render();
  
}); }
function initStock(scope) {
 scope.querySelectorAll('[data-hv-low-stock]').forEach((lowStock) => {
  if (lowStock.dataset.hvAvailabilityReady === 'true') return;
  const section = lowStock.closest('.shopify-section, dialog');
  if (!section) return;
  lowStock.dataset.hvAvailabilityReady = 'true';
  let revision = 0;
  section.addEventListener('shopify:product:select', (event) => {
   const current = ++revision;
   event.promise?.then(({detail}) => {
    if (current !== revision) return;
    if (detail?.productId && String(detail.productId) !== lowStock.dataset.productId) return;
    const updated = detail?.html?.querySelector('[data-hv-low-stock][data-product-id="' + lowStock.dataset.productId + '"]');
    lowStock.hidden = !updated || updated.hidden;
   }).catch(() => {});
  });
 });
}
function initLookbooks(scope) {
 scope.querySelectorAll('.lookbook-strip').forEach((root) => {
  if (root.dataset.afReady === 'true') return;
  root.dataset.afReady = 'true';
  function configure(vp) {
   const track = vp.querySelector('.lookbook-strip__track');
   if (track) track.style.setProperty('--lookbook-speed', (parseInt(vp.dataset.speed || '60', 10)) + 's');
  }
  root.querySelectorAll('.lookbook-strip__viewport--mobile').forEach(configure);
  if (window.matchMedia('(min-width: 750px)').matches) {
   root.querySelectorAll('.lookbook-strip__viewport--desktop').forEach((vp) => {
    if (vp.dataset.hydrated === 'true') return;
    const template = vp.querySelector('.lookbook-strip__desktop-template');
    if (!template) return;
    vp.appendChild(template.content.cloneNode(true));
    vp.dataset.hydrated = 'true';
    configure(vp);
   });
  }
 });
}
window.matchMedia('(min-width: 750px)').addEventListener('change', () => {
 document.querySelectorAll('.lookbook-strip').forEach(root => { delete root.dataset.afReady; });
 initLookbooks(document);
});
function initialize() {
 initSizeCharts(document); initReviews(document); initStock(document); initLookbooks(document);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
else initialize();
document.addEventListener('shopify:section:load', initialize);
})();
